import { z } from 'zod';

export const DISCIPLINES = [
  'STRUCTURED_CABLING',
  'CCTV',
  'ACCESS_CONTROL',
  'FIRE_ALARM',
  'INTRUSION_DETECTION',
  'AUDIO_VISUAL',
  'DAS',
] as const;
export const DisciplineSchema = z.enum(DISCIPLINES);
export type Discipline = z.infer<typeof DisciplineSchema>;

export const USER_ROLES = [
  'ESTIMATOR',
  'SENIOR_ESTIMATOR',
  'PROJECT_MANAGER',
  'EXECUTIVE_VIEWER',
  'ADMIN',
] as const;
export const UserRoleSchema = z.enum(USER_ROLES);
export type UserRole = z.infer<typeof UserRoleSchema>;

export const USER_ROLE_LEVEL: Record<UserRole, number> = {
  ESTIMATOR: 1,
  EXECUTIVE_VIEWER: 2,
  PROJECT_MANAGER: 3,
  SENIOR_ESTIMATOR: 4,
  ADMIN: 5,
};

export const ROLE_DISPLAY_NAMES: Record<UserRole, string> = {
  ADMIN: 'Admin',
  SENIOR_ESTIMATOR: 'Lead Estimator',
  PROJECT_MANAGER: 'Project Manager',
  EXECUTIVE_VIEWER: 'Executive Viewer',
  ESTIMATOR: 'Estimator',
};

export const PRIVILEGED_ROLES: readonly UserRole[] = ['ADMIN', 'SENIOR_ESTIMATOR'];
export function isPrivilegedRole(role: UserRole): boolean {
  return PRIVILEGED_ROLES.includes(role);
}

export const OFFICE_SLUGS = ['rancho', 'livermore', 'sparks'] as const;
export const OfficeSlugSchema = z.enum(OFFICE_SLUGS);
export type OfficeSlug = z.infer<typeof OfficeSlugSchema>;

export const PaginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(50),
});
export type Pagination = z.infer<typeof PaginationSchema>;

export const PaginatedResponseSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
    hasMore: z.boolean(),
  });
